import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AvpHeader from "../shared/header/AvpHeader";
import BreadCrumb from "../shared/header/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import {
  userIsLogged,
  apiGetAvpIstanzeByAvp,
  getRoute,
  apiDeleteAvpIstanza,
} from "../shared/manager/api_manager";
import { useLingueStore } from "../sistema/storeLingua";

import { useEffectOnce } from "../shared/manager/use_effect_once";
import { getValueByQueryString } from "../shared/manager/util";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
export default function GestioneAvpScreen() {
  const navigate = useNavigate();

  const [currentAvp, setCurrentAvp] = useState(null);
  const [rows, setRows] = useState([]);
  const [idToDelete, setIdToDelete] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [alertSuccessOpen, setAlertSuccessOpen] = useState(false);
  const [alertErrorOpen, setAlertErrorOpen] = useState(false);
  const { selectedLinguaTesto } = useLingueStore((state) => state);

  const breadCrumb = [
    { title: selectedLinguaTesto?.GestioneAvpIstanceBreadcrumb1, link: "/avp" },
    {
      title:
        selectedLinguaTesto?.GestioneAvpIstanceBreadcrumb2 +
        (currentAvp != null ? currentAvp : ""),
      link: null,
    },
    { title: selectedLinguaTesto?.GestioneAvpIstanceBreadcrumb3, link: null },
  ];

  useEffectOnce(() => {
    startPage();

    return () => stopPage();
  });

  function startPage() {
    console.log("startPage");

    if (userIsLogged() == false) {
      navigate("/login");
    } else {
      var route = getRoute();
      if (!route.funzioni.some((g) => g.idFunzione === 20)) {
        navigate("/");
      }
      initPage();
    }
  }

  function initPage() {
    console.log("initPage");

    const url = window.location.pathname;
    const idAvp = getValueByQueryString("idavp");
    setCurrentAvp(idAvp);
    apiGetAvpIstanzeByAvp(idAvp, avpIstanzeCallback);
  }

  function stopPage() {
    console.log("stopPage");
  }

  function avpIstanzeCallback(response) {
    console.log(response);
    if (response != null && response.status >= 200 && response.status < 400) {
      setRows(response.data);
    } else {
      setRows([]);
    }
  }

  const columns = [
    //{ field: 'idUtenteAvp', headerName: 'ID', flex: 1, headerClassName: 'tableHeader' },
    {
      field: "userName",
      headerName: selectedLinguaTesto?.GestioneAvpIstanceColumnUser,
      flex: 2,
      headerClassName: "tableHeader",
    },
    {
      field: "durataSessione",
      headerName: selectedLinguaTesto?.GestioneAvpIstanceColumnDurSession,
      flex: 1,
      headerClassName: "tableHeader",
    },
    {
      field: "qrCode",
      headerName: selectedLinguaTesto?.GestioneAvpIstanceColumnQRcode,
      flex: 1,
      headerClassName: "tableHeader",
    },
    {
      field: "pin",
      headerName: selectedLinguaTesto?.GestioneAvpIstanceColumnPIN,
      flex: 2,
      headerClassName: "tableHeader",
    },
    {
      field: "descTipoIstanza",
      headerName: selectedLinguaTesto?.GestioneAvpIstanceColumnTypeInstance,
      flex: 2,
      headerClassName: "tableHeader",
    },
    {
      field: "action",
      headerName: "",
      flex: 2,
      sortable: false,
      headerClassName: "tableHeader",
      align: "right",
      renderCell: (params) => {
        const onClick = (event) => {
          event.stopPropagation(); // don't select this row after clicking

          console.log(params.row);
          const action = event.target.dataset.action;
          if (action == "edit") handleEdit(params.row.idUtenteAvp);
          else if (action == "delete") handleDelete(params.row.idUtenteAvp);
          else if (action == "qrcode")
            handleQRCode(
              params.row.idUtenteAvp,
              params.row.idTipoIstanza,
              params.row.idUtente,
              params.row.urlBase
            );
          else if (action == "preview")
            handlePreview(
              params.row.idUtenteAvp,
              params.row.idTipoIstanza,
              params.row.idUtente,
              params.row.urlBase
            );
          else if (action == "previewinteraction") {
            handlePreviewInteraction(
              // params.row.idUtenteAvp,
              // params.row.idTipoIstanza,
              params.row.idUtente,
              params.row.urlBase
            );
          }
        };

        return (
          <div className="tableActionButton">
            <img
              data-action="edit"
              src="/images/edit_btn.svg"
              title={selectedLinguaTesto?.GestioneAvpIstanceImgEdit}
              onClick={onClick}
            />
            <img
              data-action="delete"
              data-rowid=""
              src="/images/delete_btn.svg"
              title={selectedLinguaTesto?.GestioneAvpIstanceImgDelete}
              onClick={onClick}
            />
            <img
              data-action="qrcode"
              data-rowid=""
              src="/images/qrcode_btn.svg"
              title={selectedLinguaTesto?.GestioneAvpIstanceImgQrCode}
              onClick={onClick}
            />
            <img
              data-action="preview"
              data-rowid=""
              src="/images/preview_btn.svg"
              title={selectedLinguaTesto?.GestioneAvpIstanceImgPreview}
              onClick={onClick}
            />
            <img
              data-action="previewinteraction"
              data-rowid=""
              src="/images/previewinteraction_btn.svg"
              title={
                selectedLinguaTesto?.GestioneAvpIstanceImgPreviewInteraction
              }
              onClick={onClick}
            />
          </div>
        );
      },
    },
  ];

  function handleNew() {
    const dest = "/avp/istanze/0?idavp=" + currentAvp;
    navigate(dest);
  }

  function handleEdit(idUtenteAvp) {
    const dest = "/avp/istanze/" + idUtenteAvp + "?idavp=" + currentAvp;
    navigate(dest);
  }

  function handleDelete(idUtenteAvp) {
    setIdToDelete(idUtenteAvp);
    setDeleteDialogOpen(true);
  }

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleDeleteDialogConfirm = () => {
    setDeleteDialogOpen(false);
    apiDeleteAvpIstanza(idToDelete, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setAlertSuccessOpen(true);
        setAlertErrorOpen(false);
        initPage();
      } else {
        setAlertSuccessOpen(false);
        setAlertErrorOpen(true);
      }
    });
  };

  function handleQRCode(idUtenteAvp, idTipoIstanza, idUtente, baseUrl) {
    let linkUrl = baseUrl + "/avp";
    // let linkUrl = "http://localhost:3010/avp";

    let touchLinkUrl =
      linkUrl + "/qrcode" + "?idUtente=" + idUtente + "&idAvp=" + currentAvp;
    window.open(touchLinkUrl, "_blank");
  }

  function handlePreview(idUtenteAvp, idTipoIstanza, idUtente, baseUrl) {
    // let linkUrl = "http://localhost:3010/avp";
    let linkUrl = baseUrl + "/avp";

    if (idTipoIstanza == 1) {
      let touchLinkUrl =
        linkUrl + "/touch" + "?idUtente=" + idUtente + "&idAvp=" + currentAvp;
      window.open(touchLinkUrl, "_blank");
    } else if (idTipoIstanza == 2 || idTipoIstanza == 3) {
      //olo+smartphone
      let oloLinkUrl =
        linkUrl + "/olo" + "?idUtente=" + idUtente + "&idAvp=" + currentAvp;
      let interlinkUrl =
        linkUrl +
        "/interaction" +
        "?idUtente=" +
        idUtente +
        "&idAvp=" +
        currentAvp;
      window.open(oloLinkUrl, "_blank");
      window.open(interlinkUrl, "_blank");
    }
  }

  function handlePreviewInteraction(idUtente, baseUrl) {
    let linkUrl = baseUrl + "/avp";
    // let linkUrl = "http://localhost:3010/avp";
    //if (idTipoIstanza==2 || idTipoIstanza==3) {
    //interaction
    let interlinkUrl =
      linkUrl +
      "/interaction" +
      "?idUtente=" +
      idUtente +
      "&idAvp=" +
      currentAvp;
    window.open(interlinkUrl, "_blank");
    //}
  }

  return (
    <div id="avp-gestioneavp-screen">
      <AvpHeader selectedMenuId={"avp"} />
      <BreadCrumb items={breadCrumb} helpLink={"help.html#avpistanze"} />
      <div id="avp-cms-screen-container">
        <Collapse
          in={alertSuccessOpen}
          timeout={{ enter: 1000, exit: 1000 }}
          addEndListener={() => {
            setTimeout(() => {
              setAlertSuccessOpen(false);
            }, 2000);
          }}
        >
          <Alert
            variant="filled"
            severity="success"
            onClose={() => {
              setAlertSuccessOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneAvpIstanceAlertSuccess}
          </Alert>
        </Collapse>
        <Collapse in={alertErrorOpen}>
          <Alert
            variant="filled"
            severity="error"
            onClose={() => {
              setAlertErrorOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneAvpIstanceAlertError}
          </Alert>
        </Collapse>
        <div className="avp-cms-screen-title">
          {selectedLinguaTesto?.GestioneAvpIstanceTitle}
        </div>
        <div className="avp-cms-screen-content">
          <div className="avp-cms-screen-toolbar clearfix">
            <div className="avp-cms-screen-toolbar-title">
              {rows.length}&nbsp;
              {selectedLinguaTesto?.GestioneAvpIstanceFormIstance}
            </div>
            <div className="avp-cms-screen-toolbar-filters"></div>
            <div className="avp-cms-screen-toolbar-add" onClick={handleNew}>
              <button>
                {selectedLinguaTesto?.GestioneAvpIstanceFormCreateIstance}
              </button>
            </div>
          </div>

          <DataGrid
            disableColumnMenu
            getRowId={(row) => row.idUtenteAvp}
            rows={rows}
            columns={columns}
            getRowClassName={(params) => "tableRow"}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[5]}
            disableRowSelectionOnClick
          />
        </div>
      </div>

      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {selectedLinguaTesto?.GestioneAvpIstanceAlertTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {selectedLinguaTesto?.GestioneAvpIstanceAlertDelete}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose}>
            {selectedLinguaTesto?.GestioneAvpIstanceAlertUndo}
          </Button>
          <Button onClick={handleDeleteDialogConfirm} autoFocus>
            {selectedLinguaTesto?.GestioneAvpIstanceAlertConfirm}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
